import { useGlobalOverlayBasePath } from "shared-ui/src/hooks/routedOverlays";
import { LIFECYCLE_SEGMENTS } from "@features/assets-feature/routing/lifecycleRouteSegments";
import { RoutedLifecycleEventDrawer } from "@features/assets-feature/components/asset-lifecycle-management/RoutedLifecycleEventDrawer";
import { useClaims } from "../../../../auth/ClaimsProvider";
import { ShiOnePermission } from "../../../../auth/authorizationTypes";
import { isLifecycleEventWidgetHost } from "./upcomingRenewalsRouting";

/**
 * The lifecycle event drawer the Upcoming Renewals widget opens. Mounted by each host page
 * rather than the widget, so a shared link resolves even when the widget is not shown.
 */
export default function UpcomingRenewalsEventDrawerHost() {
  const { hasPermission } = useClaims();
  const basePath = useGlobalOverlayBasePath(LIFECYCLE_SEGMENTS.event);

  if (!isLifecycleEventWidgetHost(basePath)) {
    return null;
  }

  return (
    <RoutedLifecycleEventDrawer
      basePath={basePath}
      hasAssetOrderDataManagePermission={hasPermission(
        ShiOnePermission.assetOrderDataManage,
      )}
    />
  );
}
